export default __webpack_public_path__ + "static/media/moneyPaper.2593ec0f.png";